import styled from 'styled-components';

export const Container = styled.div`
  background-color: #f4f0ec;
  min-height: 100vh;

  .infinite-scroll {
    max-height: 100vh;
    overflow: auto;

    ::-webkit-scrollbar {
      width: 0;
    }

    ::-webkit-scrollbar-thumb {
      background-color: transparent !important;
    }
  }

  p {
    font-size: 20px;
    display: flex;
    align-items: end;
    span {
      width: 215px;
    }
    b {
      border-radius: 4px;
      border: 1px solid #8c8c8c;
      min-width: 50px;
      padding: 0 10px;
    }
    small {
      margin-left: 10px;
    }
  }

  hr {
    background: #e1e1e1;
  }

  .overflow-auto::-webkit-scrollbar-thumb {
    background-color: transparent !important;
    border-radius: 4px;
  }
`;

export const Hero = styled.div`
  max-width: 100%;
  height: 187px;
`;

export const Event = styled.div`
  height: calc(100vh - 230px);

  .btn-signout {
    background-color: #ff003d;
    color: #fff;
  }
`;
